import { apiClient, __isNil } from '../../utils';
import { uploadMedia, handleError } from '..';

export const editMenu = async ({
  siteId,
  itemID,
  name,
  icon,
  url,
  items,
  image,
}) => {
  try {
    const data = {
      siteID: siteId,
      itemID,
      name,
      url,
      ...(!__isNil(icon) ? { icon } : {}),
      ...(items.length ? { items } : {}),
      ...(__isNil(image) ? { clearLogo: true } : {}), // this will remove the menu's image
    };
    await apiClient.post('/merchant/menu/editItem', {
      data,
    });

    if (image instanceof File) {
      const mediaPayload = {
        site: siteId,
        foreign_id: itemID,
        mc: name,
        menuLogo: image,
      };
      await uploadMedia(mediaPayload, { endpoint: '/merchant/media/upload' });
    }

    return;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
